<!-- <div class="row inner justify-content-center inner--no-vertical-wrap width-99" style="text-align: center;margin-top: 40px">
  <div class="col-2" style="border-top: 1px solid;height: 900px">
      <h2>Library Browser</h2><br>
      <app-lib-browser (selectedAsset)="selectAsset($event)"></app-lib-browser>
  </div>
  <div class="col-6" style="border: 1px solid; border-bottom: 0px">
      <h2>Specification(Experienced)</h2>
      <app-asset-specification [asset]="selectedAsset"></app-asset-specification>
  </div>
  <div class="col-4" style="border-top: 1px solid">
      <h2>Detailed Information</h2>
      <app-asset-information [attributes]="attributes"></app-asset-information>
  </div>
</div> -->

<!-- <sh-page theme='dark'>
        <sh-access-bar slot='access'>
          <sh-user-identifier slot='user' name='User Name' info='Hospital / Company'></sh-user-identifier>
        </sh-access-bar>
        <sh-nav-bar slot='nav'>
            <sh-tabs>
                  <sh-tab-item label="Home"></sh-tab-item>
                  <sh-tab-item label="Search the Lib" active></sh-tab-item>
                  <sh-tab-item label="Personal Browser"></sh-tab-item>
            </sh-tabs>
        </sh-nav-bar> -->
<!-- <div>
    <sh-grid style="padding-top: 0">
        <div columns="2" style="border-right: 1px solid #656464;margin: 0; margin-top: -3%; height:100vh; "
            (click)="httpService.contextmenu ? disableContextMenu() : ''">
            <div style="padding-top: 1em">
                <div class="center-align">

                    <sh-text style="font:var(--header-1);">Library Browser</sh-text>
                </div>

                <div style="padding-right: 10px">
                    <sh-input-text label='Search' (keyup)="search($event)" [(value)]="searchKey" (click)="clear($event)"
                        id="searchText"></sh-input-text>
                </div>
                <div style="padding-bottom: 20px;overflow-y: auto;height:75vh" id="libBrowserDiv">
                    <app-library-browser [assetLibrary]="library" (selectedAsset)="selectAsset($event)"
                        (folderSelected)="folderselected($event)" #libBrowser [isPersonalBrowser]="false">
                    </app-library-browser>
                </div>

            </div>
        </div>
        <div columns="10" style="text-align: center" class="emptyState cursor-pointer"
            *ngIf="!asset.relativePath && httpService.folder?.name && httpService.folder?._id"
            routerLink="/val-assets/upload-assets" (click)="httpService.contextmenu ? disableContextMenu() : ''"
            id="uploadAssetFolder">

            <sh-icon slot="functions" icon="upload-user" id="shicon"></sh-icon><br>
            <sh-text style="font:var(--super-header);padding-top:14px;">Click here to upload asset in
                <span *ngIf=" httpService.folder?.name" style="font:var(--super-header);">
                    {{ httpService.folder?.name }}</span>
            </sh-text>

        </div>
        <div columns="6" style="margin: 0; padding-left: 5%;padding-right: 5%;" *ngIf="asset.relativePath"
            (click)="httpService.contextmenu ? disableContextMenu() : ''">
            <div style="padding-top: 0.2em">
                <app-asset-specification *ngIf="asset?.attributes" [assetPath]="asset.relativePath" [asset]="asset"
                    [formats]="formats" [quality]="quality" [textureQuality]="textureQuality"
                    (uneditedAssetEmit)="assignAsset($event)" (selectedAssetFile)="selectedAssetFile($event)"
                    (deleteEmit)="collapseFolder($event)">
                </app-asset-specification>

            </div>
        </div>
        <div columns="4" style="border-left: 1px solid #656464;margin: 0;margin-top: -3%;" *ngIf="asset.relativePath"
            (click)="httpService.contextmenu ? disableContextMenu() : ''">
            <div style="padding: 1em; padding-top: 1.3em">
                <div class="center-align" style="padding-bottom: 1em;">

                    <sh-text style="font:var(--header-1);">Detailed Information</sh-text>
                </div>
                <div *ngIf="loadAsset">
                    <app-asset-information *ngIf="asset.relativePath" [attributes]="asset.attributes"
                        [tags]="asset.tags" [filePath]="assetFilePath"></app-asset-information>
                </div>

            </div>
        </div>
    </sh-grid>
</div> -->

<!-- <app-asset-specification *ngIf="asset?.attributes" [assetPath]="asset.relativePath" [asset]="asset" [formats]="formats"
    [quality]="quality" [textureQuality]="textureQuality" [assetFilePath]="assetFilePath" [loadAsset]="loadAsset"
    (uneditedAssetEmit)="assignAsset($event)" (selectedAssetFile)="selectedAssetFile($event)"
    (deleteEmit)="collapseFolder($event)">
</app-asset-specification> -->
<!-- <sh-icon slot="left" button icon="menu" style="position: fixed; top: 70px; left: 10px;z-index: 10;"
    onclick="document.getElementById('drawer-left').visible = 'true'"></sh-icon>

<div style="overflow-y: auto; height: calc(100vh - 55px)" *ngIf="asset.attributes">
    <div *ngIf="loadAsset">
        <app-asset-information *ngIf="asset.relativePath" [attributes]="asset.attributes" [tags]="asset.tags"
            [filePath]="assetFilePath"></app-asset-information>
    </div>
    <div style="height: 100px; background-color: black;margin-top: -3%; padding-left: 16px; padding-right: 16px">
        <br>
        <div class="assetInfo" style="margin-top: 5px">
            <div class="details">
                <sh-text style="font:var(--super-header);display: contents" class="font-orrange">
                    {{asset.name}}</sh-text>
                <sh-user-identifier name={{asset.attributes.primaryContact.name}}></sh-user-identifier>
            </div>
            <div style="margin-top: -1%;margin-left: 0.5%;">
                <app-rating [rating]="asset.avgRating" [aseetId]="asset._id"></app-rating>
            </div>
            <div class="details">
                <svg height="16" width="16" *ngIf="asset.attributes.productStatus === 0">
                    <circle cx="10" cy="10" r="6" fill="#efdd59" />
                </svg>
                <svg height="16" width="16" *ngIf="asset.attributes.productStatus === 1">
                    <circle cx="10" cy="10" r="6" fill="#57EE1E" />
                </svg>
                <span>
                    <sh-text
                        style="font:var(--header-1); padding: 10px;margin-block-start: -30px; margin-inline-start: 20px;">
                        {{asset.attributes.productStatus | productStatus}}

                    </sh-text>
                </span>
            </div>
            <div class="details">
                <sh-dropdown *ngIf="versionList && versionList.length > 0 && !renameEnable" id="dropdowntextture"
                    label='Version' [value]=selectedVersion
                    style="width: 7em;display: -webkit-inline-box;padding: 0;margin-top: -1.6em;margin-left: 0.25em">
                    <sh-menu-item *ngFor="let v of versionList;let i = index" id="h{{i}}"
                        label="{{v.version}}{{v.deleted ? ' - deleted' : ''}}"
                        (click)="selectedVersion = v.version; changeVersion(v.version)" [disabled]="v.deleted">
                    </sh-menu-item>
                </sh-dropdown>
            </div>
            <div class="details" style="margin-top: -5px">
                <div class="assetInfo">
                    <sh-icon color="secondary" icon="favorite" style="font-size: 18px"></sh-icon>
                    <sh-text style="font:var(--body-1);margin-top: 10px;margin-left: -10px;">{{asset.noOfRatings}}
                    </sh-text>
                </div>
            </div>
            <div class="details" style="margin-top: -5px">
                <sh-text style="font:var(--title-1); padding: 10px;">
                    Publiched {{asset.attributes.creationDate | dateToInterval}}

                </sh-text>
            </div>
            <div class="details cursor-pointer" style="margin-top: -4px" (click)="inform(asset)" id="divSubscribe">
                <svg *ngIf="!asset.inform" class="heart" viewBox="0 0 32 29.6">
                    <path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                              c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z" />
                </svg>
                <svg *ngIf="asset.inform" class="heart-selected" viewBox="0 0 32 29.6">
                    <path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                              c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z" />
                </svg>

            </div>
            <div class="details cursor-pointer" style="margin-top: 5px;" (click)="inform(asset)">
                <sh-text style="font:var(--header-1);">Keep me informed</sh-text>
            </div>
            <div class="details" style="margin-left: auto;">
                <sh-button style="float: right; margin-right: 0.5em" shape="pill-m" label='Download'
                    (click)="download()" id="btndownload"></sh-button>
                <sh-button style="float: right; margin-right: 0.5em" color="secondary" *ngIf="showEdit" shape="pill-s"
                    label='Modify' id="modifyAsset"
                    onclick="document.getElementById('my-modal').setAttribute('visible', 'true')"
                    (click)="modifyAsset()"></sh-button>
                <sh-button style="float: right; margin-right: 0.5em" color="secondary" *ngIf="showEdit" shape="pill-s"
                    id="deleteAsset" label='Delete' (click)="deleteConfirmationPopUp()">
                </sh-button>
            </div>

        </div>
    </div>

    <div style="padding: 16px;">
        <sh-grid>
            <div columns="7" col-m="12" col-s="12">
                <sh-tabs>

                    <sh-tab-item label="Last Visited" [active]="assetSuggestion === 1">
                    </sh-tab-item>
                    <sh-tab-item label="Recommended" disabled></sh-tab-item>
                    <sh-tab-item label="Latest" disabled></sh-tab-item>
                </sh-tabs>
                <div *ngIf="assetSuggestion === 1">
                    <app-last-visited [assets]="userService.loggendInUser.assetsRecentlyViewed"></app-last-visited>
                </div>
            </div>
            <div columns="5" col-m="12" col-s="12" *ngIf="asset?.comments">

                <app-comments [asset]="asset" [selectedVersion]="2">Loading...</app-comments>

            </div>
        </sh-grid>

    </div>

</div> -->

<sh-page class="page-wrapper" theme={{theme_color}}>
    <div #folderShow [ngClass]="{'dropdown': showAssetCategory==false,'dropdownSelect': showAssetCategory}"
        [ngStyle]="{'background-color': theme_color=='dark'?'#383838':'#FFFFFF'}" *ngIf="!asset.relativePath"
        (mouseenter)="hideFolder()" (mouseleave)="showFolderCategory()">
        <br>
        <ng-container *ngIf="showAssetCategory">

            <sh-grid class="show-asset-category-grid">
                <ng-container *ngIf="!isConfigurationVisible">
                    <div columns="4" col-m="12" col-s="12" class="show-asset-category-div">
                        <sh-text class="font-title-1 folderNames"> Business Structure
                        </sh-text>
                    </div>
                    <div columns="4" col-m="12" col-s="12" class="show-asset-category-div">
                        <sh-text class="font-title-1 folderNames"> Product Family
                        </sh-text>
                    </div>
                    <div columns="4" col-m="12" col-s="12" class="show-asset-category-div">
                        <sh-text class="font-title-1 folderNames"> Product
                        </sh-text>
                    </div>
                </ng-container>
                <ng-container *ngIf="isConfigurationVisible">
                    <div columns="3" col-m="12" col-s="12" class="show-asset-category-div">
                        <sh-text class="font-title-1 folderNames"> Business Structure
                        </sh-text>
                    </div>
                    <div columns="3" col-m="12" col-s="12" class="show-asset-category-div">
                        <sh-text class="font-title-1 folderNames"> Product Family
                        </sh-text>
                    </div>
                    <div columns="3" col-m="12" col-s="12" class="show-asset-category-div">
                        <sh-text class="font-title-1 folderNames"> Product
                        </sh-text>
                    </div>
                    <div columns="3" col-m="12" col-s="12" class="show-asset-category-div">
                        <sh-text class="font-title-1 folderNames"> Configuration
                        </sh-text>
                    </div>
                </ng-container>
            </sh-grid>
            <sh-divider></sh-divider>
            <sh-grid>
                <div *ngIf="businessStructure.length == 0 && product.length == 0 && productFamily.length == 0">
                    <sh-text>Loading...</sh-text>
                </div>
                <ng-container *ngIf="!isConfigurationVisible">
                    <div columns="4" label="Business Structure" col-m="12" col-s="12" class="row">
                        <sh-text *ngFor="let item of businessStructure" class="folderNames">
                            <a (click)="selectBusinessCategory(item)"
                                [ngClass]="{'selectFolder': item.selected==true, 'unselectFolder': !item.selected}">
                                {{item.name}}</a>
                        </sh-text>
                    </div>
                    <div columns="4" label="Product Family" col-m="6" col-s="12" class="row">
                        <sh-text *ngFor="let item of productFamily" class="folderNames">
                            <a (click)="selectProductFamily(item)"
                                [ngClass]="{'selectFolder': item.selected==true, 'unselectFolder': !item.selected}">
                                {{item.name}}</a>
                        </sh-text>
                    </div>
                    <div columns="4" label="Product" col-m="6" col-s="12" class="row">
                        <sh-text *ngFor="let item of product" class="folderNames">
                            <a (click)="selectProduct(item)"
                                [ngClass]="{'selectFolder': item.selected==true, 'unselectFolder': !item.selected}">
                                {{item.name}}</a>
                        </sh-text>
                    </div>
                </ng-container>
                <ng-container *ngIf="isConfigurationVisible">
                    <div columns="3" label="Business Structure" col-m="12" col-s="12" class="row">
                        <sh-text *ngFor="let item of businessStructure" class="folderNames">
                            <a (click)="selectBusinessCategory(item)"
                                [ngClass]="{'selectFolder': item.selected==true, 'unselectFolder': !item.selected}">
                                {{item.name}}</a>
                        </sh-text>
                    </div>
                    <div columns="3" label="Product Family" col-m="6" col-s="12" class="row">
                        <sh-text *ngFor="let item of productFamily" class="folderNames">
                            <a (click)="selectProductFamily(item)"
                                [ngClass]="{'selectFolder': item.selected==true, 'unselectFolder': !item.selected}">
                                {{item.name}}</a>
                        </sh-text>
                    </div>
                    <div columns="3" label="Product" col-m="6" col-s="12" class="row">
                        <sh-text *ngFor="let item of product" class="folderNames">
                            <a (click)="selectProduct(item)"
                                [ngClass]="{'selectFolder': item.selected==true, 'unselectFolder': !item.selected}">
                                {{item.name}}</a>
                        </sh-text>
                    </div>
                    <div columns="3" label="Configuration" col-m="6" col-s="12" class="row">
                        <sh-text *ngFor="let item of configurationFolders" class="folderNames">
                            <a (click)="selectConfiguration(item)"
                                [ngClass]="{'selectFolder': item.selected==true, 'unselectFolder': !item.selected}">
                                {{item.name}}</a>
                        </sh-text>
                    </div>
                </ng-container>
            </sh-grid>
        </ng-container>
    </div>

    <sh-pane class="personal-browser-pane" slot='left' behavior="collapse" [size]="panDisplay" *ngIf="isPersonalBrowser">
        <div>
            <app-library-browser [assetLibrary]="library" [searchAssetLibrary]="searchAssetLibrary" class="outline-none"
                (selectedAsset)="selectAsset($event)" (folderSelected)="folderselected($event)"
                (assetCardId)="fetchCardDetails($event)" #libBrowser [isPersonalBrowser]="isPersonalBrowser"
                (assetRelativePath)="assetRelativePathRecive($event)" (parameterUrl)="parameterUrl($event)">
            </app-library-browser>
        </div>
    </sh-pane>

    <!-- <sh-icon slot="left" button icon="menu" style="position: fixed; top: 70px; left: 10px;z-index: 10;"
  onclick="document.getElementById('drawer-left').visible = 'true'"></sh-icon> -->
    <div class="folder-breadcrump-div" *ngIf="!asset.relativePath || (searchedResults!==null)">
        <div class="folder-breadcrump-font">
            <span class="font-body-2 position-relative folder-breadcrump-span"
                *ngFor="let folderbreadcrump of arrayParams; let i = index">
                <b id="textAssetPath" *ngIf="i < arrayParams.length-1; else orangeText">
                    <a
                        (click)="pathUrlFOlder(folderbreadcrump)" class="pointer-events-cursor"
                        id="breadCrump">{{folderbreadcrump}}
                    </a>
                    <sh-icon icon="play" class="breadcrump-path">
                    </sh-icon>
                </b>
                <ng-template #orangeText>
                    <b class="font-orrange">{{folderbreadcrump}}</b>
                </ng-template>
            </span>
        </div>
        <br>
        <!--Filter implementation starts-->
        <ng-container>
            <sh-grid fit-content="true" class="position-relative display-flex-row filter-grid">
                <div columns="2" col-m="6" col-s="6">
                    <sh-text class="filter-by-text" size="body-1">Filter by</sh-text>
                </div>
                <div columns="2" col-m="6" col-s="6">
                </div>
            </sh-grid>
            <sh-grid fit-content="true" class="position-relative extension-grid">
                <div class="extension-grid-div" columns="2" col-m="12" col-s="12">
                    <sh-accordion id="extensionFilter" label="File Extension"
                        (click)="isExtensionExpanded=!isExtensionExpanded" [expanded]="isExtensionExpanded"
                        class="filterItem accordion-width">
                        <sh-checkbox id="extensionCheckbox" *ngFor="let item of extension;" [label]="item"
                            [active]="checkedExtension.includes(item)"
                            (click)="filterSelected(item,'extension');extensionAccordianOpen()" #extensionCheckboxes>
                        </sh-checkbox>
                    </sh-accordion>
                </div>
                <div  class="restriction-filter-div" columns="2" col-m="12" col-s="12">
                    <sh-accordion id="restrictionFilter" label="Restriction"
                        (click)="isRestrictionExpanded=!isRestrictionExpanded" [expanded]="isRestrictionExpanded"
                        class="filterItem accordion-width">
                        <sh-checkbox id="restrictionCheckbox" *ngFor="let item of restriction"
                            [label]="+item | productStatus" [active]="checkedRestrictions.includes(item)"
                            (click)="filterSelected(item,'restriction');restrictionAccordianOpen();"
                            #restrictionCheckboxes></sh-checkbox>
                    </sh-accordion>
                </div>
                <div class="tag-filter-div" columns="2" col-m="12" col-s="12">
                    <sh-accordion id="tagFilter" label="Tags" (click)="isTagExpanded=!isTagExpanded"
                        [expanded]="isTagExpanded" class="filterItem accordion-width">
                        <sh-checkbox id="tagCheckbox" *ngFor="let item of tag" [label]="item"
                            [active]="checkedTags.includes(item)"
                            (click)="filterSelected(item,'tag');tagAccordianOpen();" #tagCheckboxes>
                        </sh-checkbox>
                    </sh-accordion>
                </div>
                <!-- <sh-button shape='circle' color='tertiary' icon='filter' tooltip='top' label='Advance Filter' onclick="document.getElementById('advanceFilterModal').setAttribute('visible','true')"></sh-button> -->
                <div columns="1" col-m="12" col-s="12" class="apply-filter-btn">
                    <sh-button id="applyFilterBtn" label='Apply' (click)="applyFilters()"></sh-button>
                </div>
                <div columns="1" col-m="12" col-s="12" class="apply-filter-btn">
                    <sh-button id="clearFilterBtn"
                        [disabled]="filterTagsArr.length <=0 && selectedSort == null
                     && selectedBusinessFolders.length<=0 && selectedProductFamilyFolders.length<=0 && selectedProductFolders.length<=0"
                        color='secondary' label='Clear' (click)="clearFilter();changeActive($event)">
                    </sh-button>
                </div>
                <div columns="1" col-m="12" col-s="12" class="apply-filter-btn">
                    <sh-button id="applyFilterBtn" [disabled]="filterListElements()" label='Save'
                        onclick="document.getElementById('saveFilterModal').setAttribute('visible','true')"></sh-button>
                </div>
                <div class="position-relative display-flex-row" columns="1" col-m="6" col-s="6">
                    <sh-icon icon='filter' id="filterTarget" [disabled]="personalFilter===undefined"></sh-icon>
                    <!-- advanceFilterModal -->
                    <!-- <sh-badge style="background: #cf4b00;position: absolute;top: -4px;left: 22px;" [label]="personalFilter?.customUserFilters.length"></sh-badge> -->
                    <sh-popover class="personal-filter-popover" label="Personal Filters" target="filterTarget" position="bottom-left"
                        *ngIf="personalFilter!==undefined">
                        <sh-menu-item (click)='changeActive($event)'
                            *ngFor="let personal of personalFilter.customUserFilters" [label]="personal.customTag"
                            (click)='applySelectedSavedFilter(personal.filters)'>
                            <sh-icon slot="functions" button size="s" icon="edit"
                                onclick="document.getElementById('renameFilterModal').setAttribute('visible','true')"
                                (click)="actionEvent($event,personal);targ=tempFilter.customTag"></sh-icon>
                            <sh-icon slot="functions" button size="s" icon="delete"
                                onclick="document.getElementById('deleteConfirmationModal').setAttribute('visible','true')"
                                (click)="actionEvent($event,personal)"></sh-icon>
                        </sh-menu-item>
                    </sh-popover>
                    <sh-text *ngIf="personalFilter!==undefined">{{' ('+personalFilter.customUserFilters.length+')'}}
                    </sh-text>
                    <!-- <sh-icon icon="menu" id="target-1" button style="margin: 0px 22px;"
                        onclick="document.getElementById('advFilterModal').setAttribute('visible','true')">
                    </sh-icon>
                    <sh-tooltip label="Advanced Filters" target="target-1" placement="bottom" variation="short">
                    </sh-tooltip> -->
                </div>
                <div class="filter-dropdown-div" columns="2" col-m="12" col-s="12"
                    [ngClass]="{ 'no-pointer-events' : !(searchResults || assetsCardDetails) }">
                    <sh-dropdown class="filter-dropdown" label='Sort by' [value]="selectedSort"
                        id="sort_assets">
                        <sh-menu-item label='Name' (click)="selectedSort='Name'; sortAssets(0)"></sh-menu-item>
                        <sh-menu-item label='Ratings' (click)="selectedSort='Ratings'; sortAssets(1)"></sh-menu-item>
                        <sh-menu-item label='Created Date' (click)="selectedSort='Created Date'; sortAssets(2)">
                        </sh-menu-item>
                        <sh-menu-item label='Updated Date' (click)="selectedSort='Updated Date'; sortAssets(3)">
                        </sh-menu-item>
                        <sh-menu-item label='Relevance' (click)="selectedSort='Relevance'; sortAssets(4)">
                        </sh-menu-item>
                    </sh-dropdown>
                </div>
            </sh-grid>
        </ng-container>
        <br>
        <div class="display-flex-wrap">
            <sh-tag class="filter-tag" *ngFor="let item of filterTagsArr" [label]="getShortenedNameForTag(item)">
            </sh-tag>
            <sh-tag label="{{item.name}}" *ngFor="let item of selectedBusinessFolders"
                (closed)="onSelectionChange(item,1)" removable class="selectedFoldersTag"></sh-tag>
            <sh-tag label="{{item.name}}" *ngFor="let item of selectedProductFamilyFolders"
                (closed)="onSelectionChange(item,2)" removable class="selectedFoldersTag"></sh-tag>
            <sh-tag label="{{item.name}}" *ngFor="let item of selectedProductFolders"
                (closed)="onSelectionChange(item,3)" removable class="selectedFoldersTag"></sh-tag>
        </div>
        <div class="filter-tag-div" *ngIf="filterTagsArr.length>0"></div>
        <!--Filter implementation ends-->

        <sh-modal id="saveFilterModal" label='Save Filter' modal-height='200px' modal-width='320px'>
            <sh-text size='title-2' color="primary">Enter a name for the custom filter</sh-text>
            <sh-input-text (value-changed)="targ=$event.target.value" label='Filter Name'
                [error]="filterNameControl.invalid && filterNameValidFlag" [formControl]="filterNameControl"
                ngDefaultControl [value]="targ" (blur)="checkInput(targ)"></sh-input-text>
            <sh-button color='secondary' slot='footer' label='Cancel'
                onclick="document.querySelector('#saveFilterModal').visible = false"></sh-button>
            <sh-button slot='footer' [disabled]="filterNameControl.invalid" label='Save'
                onclick="document.querySelector('#saveFilterModal').visible = false" (click)="saveFilters(targ)">
            </sh-button>
        </sh-modal>

        <sh-modal id="renameFilterModal" label='Rename Filter' modal-height='220px' modal-width='320px'>
            <sh-text size='title-2' color="primary">Enter a new name for the current filter</sh-text>
            <sh-input-text #data [value]="targ" (keyup)="checkInput(data.value)" [error]="filterNameValidFlag"
                [formControl]="filterNameControl" ngDefaultControl error-message="Filter name already exists">
            </sh-input-text>
            <sh-button color='secondary' slot='footer' label='Cancel'
                onclick="document.querySelector('#renameFilterModal').visible = false"></sh-button>
            <sh-button slot='footer' [disabled]="filterNameControl.invalid || checkNameExists(data.value)" label='Save'
                onclick="document.querySelector('#renameFilterModal').visible = false"
                (click)="renameFilter(data.value)"></sh-button>
        </sh-modal>

        <sh-modal id="deleteConfirmationModal" label='Delete Filter' modal-height='200px' modal-width='320px'>
            <sh-text size='title-1' color="primary" *ngIf="tempFilter!==undefined">Do you want to delete the selected
                filter {{tempFilter.customTag}}?</sh-text>
            <sh-button color='secondary' slot='footer' label='Cancel'
                onclick="document.querySelector('#deleteConfirmationModal').visible = false"></sh-button>
            <sh-button slot='footer' label='Ok'
                onclick="document.querySelector('#deleteConfirmationModal').visible = false" (click)="deleteFilter()">
            </sh-button>
        </sh-modal>

        <sh-modal id="saveMaxFilterModal" [visible]="maxFilter" label='Delete Filter' modal-height='200px'
            modal-width='320px'>
            <sh-text size='title-2' color="primary">Maximum filters that can be saved is 8. Please delete an existing
                filter and then save.</sh-text>
            <sh-button color='secondary' slot='footer' label='Cancel'
                onclick="document.querySelector('#saveMaxFilterModal').visible = false"></sh-button>
            <sh-button slot='footer' label='Ok' onclick="document.querySelector('#saveMaxFilterModal').visible = false"
                (click)="maxFilter = false">
            </sh-button>
        </sh-modal>

        <!--Advance Filter Modal-->
        <!-- <sh-modal id='advFilterModal' label='Advanced Filter' modal-height="450px" modal-width="800px">
            <sh-grid style="overflow: auto;">
                <div columns="5">
                    <sh-text size="title-2">Size</sh-text>
                    <sh-radio-group [value]="radioGroupValue" (value-changed)="radioGroupValue = $event.target.value">
                        <sh-radio-button label="All" [active]="radioGroupValue === 0"
                            (click)="enableCustomSize = false; radioGroupValue=0"></sh-radio-button>
                        <sh-radio-button label="Large (>500 MB)" [active]="radioGroupValue === 1"
                            (click)="enableCustomSize = false; radioGroupValue=1"></sh-radio-button>
                        <sh-radio-button label="Medium (200-499 MB)" [active]="radioGroupValue === 2"
                            (click)="enableCustomSize = false; radioGroupValue=2"></sh-radio-button>
                        <sh-radio-button label="Small (1-199 MB)" [active]="radioGroupValue === 3"
                            (click)="enableCustomSize = false; radioGroupValue=3"></sh-radio-button>
                        <sh-radio-button label="Custom" (click)="enableCustomSize = true; radioGroupValue=4">
                        </sh-radio-button>
                    </sh-radio-group>
                    <br>
                    <sh-divider></sh-divider>
                    <br>
                    <div>
                        <sh-text size="title-2">Set up a custom size</sh-text>
                        <sh-input-text #zed label="Size in MB" [disabled]="!enableCustomSize"
                            (keyup)="customFileSize = zed.value">
                        </sh-input-text>
                    </div>
                </div>
                <div columns="2">
                    <sh-divider vertical style="margin: 0 50%;"></sh-divider>
                </div>
                <div columns="5">
                    <sh-text size="title-2">Date Modified</sh-text>
                    <sh-dropdown [value]="dateModified" (value-changed)="dateModified = $event.target.value">
                        <sh-menu-item label='All' (click)="enableCustomDateModified = false" value="All"></sh-menu-item>
                        <sh-menu-item label='Last Week' (click)="enableCustomDateModified = false" value="Last Week">
                        </sh-menu-item>
                        <sh-menu-item label='Today' (click)="enableCustomDateModified = false" value="Today">
                        </sh-menu-item>
                        <sh-menu-item label='Custom' (click)="enableCustomDateModified = true" value="Custom">
                        </sh-menu-item>
                    </sh-dropdown>
                    <br>
                    <sh-datepicker #date1 label='Date Range' range future-date-disable *ngIf="enableCustomDateModified"
                        (value-changed)="customModifiedDate = date1.value"></sh-datepicker>
                    <br>
                    <sh-divider></sh-divider>
                    <br>
                    <sh-text size="title-2">Date Published</sh-text>
                    <sh-dropdown [value]="datePublished" (value-changed)="datePublished = $event.target.value">
                        <sh-menu-item label='All' (click)="enableCustomDatePublished = false" value="All">
                        </sh-menu-item>
                        <sh-menu-item label='Last Week' (click)="enableCustomDatePublished = false" value="Last Week">
                        </sh-menu-item>
                        <sh-menu-item label='Today' (click)="enableCustomDatePublished = false" value="Today">
                        </sh-menu-item>
                        <sh-menu-item label='Custom' (click)="enableCustomDatePublished = true" value="Custom">
                        </sh-menu-item>
                    </sh-dropdown>
                    <br>
                    <sh-datepicker #date2 label='Date Range' range future-date-disable *ngIf="enableCustomDatePublished"
                        (value-changed)="customPublishedDate = date2.value"></sh-datepicker>
                </div>
            </sh-grid>
            <sh-button color='secondary' slot='footer' label='Cancel'
                onclick="document.querySelector('#advFilterModal').visible = false" (click)="clearAdvanceFilter()">
            </sh-button>
            <sh-button color='secondary' slot='footer' label='Apply' (click)="advanceFilterData()"
                onclick="document.querySelector('#advFilterModal').visible = false"></sh-button>
        </sh-modal> -->

        <div *ngIf="assetsCardDetails && assetsCardDetails.length>0 && !searchResults">

            <sh-text class="font-super-header">Assets in {{ httpService.folder?.name }}</sh-text>
            <sh-grid>
                <div columns="12">
                    <sh-grid>
                        <!-- <div columns="2" col-m="4" col-s="12" *ngIf="!isPersonalBrowser && uploadToken"
                          style="outline: none; position: relative" id="asset_card_upload"
                          (click)="httpService.contextmenu ? disableContextMenu() : ''"
                          routerLink="/val-assets/upload-new-asset/{{params}}">
                          <div style="padding-top:10px;display: flex;" id="add_asset_card">
                              <sh-card card-height='300px' class="cursor-pointer" id="card_plus">
                                  <div class="uploadCard" style="position: absolute; top: 45%; left: 33%;">
                                      <sh-icon color="secondary" icon="plus" style="font-size: 80px;" id="plus_asset">
                                      </sh-icon>
                                      <sh-text style="font:var(--super-header);padding-top:14px;">Add Asset
                                      </sh-text>
                                  </div>

                              </sh-card>
                          </div>
                      </div> -->
                        <div class="cursor-pointer" columns="2" col-m="4" col-s="12"
                            *ngFor="let asset of assetsCardDetails">
                            <app-asset-card [asset]="asset"></app-asset-card>
                        </div>
                    </sh-grid>
                </div>
            </sh-grid>
        </div>
        <div *ngIf="searchResults">

            <sh-grid class="search-result-grid" *ngIf="searchResults.assets">
                <div class="search-result-div" columns="12">
                    <sh-grid>
                        <div columns="2" col-m="4" col-s="12" *ngFor="let asset of searchResults.assets">
                            <app-asset-card [asset]="asset"></app-asset-card>
                        </div>
                    </sh-grid>
                </div>
            </sh-grid>

            <div class="related-tag-div" *ngIf="searchResults.tags && searchResults.tags.length > 0">
                <sh-text size='header-1'>Related Tag(s)</sh-text>
                <div class="display-flex-wrap">
                    <sh-tag class="related-tag" [label]="tag" *ngFor="let tag of searchResults.tags"
                        (click)="searchTag(tag)"></sh-tag>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="asset.relativePath">
        <div class="asset-attribute-div" *ngIf="asset.attributes">
            <div class="asset-attribute-font">
                <span class="position-relative font-body-2"
                    [ngStyle]="{'color':theme_color==='dark'?'white':'black'}"
                    *ngFor="let path of asset.relativePath?.split(','); let i = index">
                    <ng-container *ngIf="breadCrumbClicked">
                        <b id="textAssetPath" *ngIf="i < asset.relativePath?.split(',').length-1; else orangeText"><a
                                class="pointer-events-cursor" id="breadCrump">{{path}}</a>
                            <sh-icon icon="play" class="breadcrump-path">
                            </sh-icon>
                        </b>
                    </ng-container>
                    <ng-container *ngIf="!breadCrumbClicked">
                        <b id="textAssetPath" *ngIf="i < asset.relativePath?.split(',').length-1; else orangeText"><a
                                class="pointer-events-cursor" (click)="pathUrl(path)" id="breadCrump">{{path}}</a>
                            <sh-icon icon="play" class="breadcrump-path">
                            </sh-icon>
                        </b>
                    </ng-container>
                    <ng-template #orangeText>
                        <b class="font-orrange breadcrump-subpath">{{path}}</b>
                    </ng-template>
                </span>
            </div>
            <div *ngIf="loadAsset" class="position-relative" id="{{asset._id}}">
                <app-asset-information *ngIf="asset.relativePath" [attributes]="asset.attributes" [tags]="asset.tags"
                    [filePath]="filePath" [previewBackgroudColor]="previewBackgroundColor" [snapshotURL]="snapshotImage"
                    [uploadedURL]="uploadedImages" (setPolygonCount)="setPolygonCount($event)">
                </app-asset-information>

                <!-- <sh-button class="showDetails" color='Tertiary' label='Details'
                  style="position: absolute; right: 5em; bottom: 2em"></sh-button> -->
                <sh-icon id="specification" class="showDetails" icon="document" tabindex="1" button
                    (click)="showSpecifications = !showSpecifications">
                </sh-icon>
                <sh-tooltip label="Specification" target="specification" placement="top" variation="short"></sh-tooltip>

                <!-- <sh-icon class="closeDetails" icon="document" tabindex="1" button
                  style="position: absolute; right: 10%; bottom: 6.5%" *ngIf="showSpecifications"
                  (click)="showSpecifications = !showSpecifications">
              </sh-icon> -->
                <ng-container *ngIf="showSpecifications">
                    <div class="assetDetails outline-none" tabindex="2" #detailsAsset>
                        <!-- <div class="initialDetails">
                      <sh-text style="font: var(--title-1)">Specifications</sh-text>
                  </div> -->
                        <div class="innerDetails" [ngStyle]="{'color':theme_color==='dark'?'#1E1E1E':'#EBEBEB'}">
                            <sh-grid>
                                <div columns="12">
                                    <sh-text class="font-title-1">Specifications</sh-text>
                                </div>
                                <div columns="4">
                                    <sh-text class="font-title-1">3D Model</sh-text>
                                </div>
                                <div columns="8">
                                    <sh-text class="asset-spec-details">Quality</sh-text>
                                    <sh-text class="font-body-1" *ngFor="let q of quality">{{q | quality}}
                                    </sh-text>
                                    <sh-text class="asset-spec-details asset-spec-details-text">File
                                        Format
                                    </sh-text>
                                    <sh-text class="font-body-1" *ngFor="let format of formats">.{{format}}
                                    </sh-text>
                                </div>

                                <div columns="4">
                                    <sh-text class="font-title-1">Texture</sh-text>
                                </div>
                                <div columns="8">
                                    <sh-text class="asset-spec-details">Quality</sh-text>
                                    <sh-text class="font-body-1" *ngFor="let q of textureQuality">
                                        {{q | quality}}
                                    </sh-text>
                                </div>
                                <div columns="12" *ngIf="selectedAsset.specification.rigged">
                                    <sh-text class="asset-spec-details">Rigged</sh-text>
                                </div>
                                <div columns="12" *ngIf="selectedAsset.specification.animation">
                                    <sh-text class="asset-spec-details">Animation</sh-text>
                                </div>

                                <div columns="4">
                                    <sh-text class="font-title-1">Polygon Count</sh-text>
                                </div>
                                <div columns="8">
                                    <sh-text class="asset-spec-details">
                                        {{selectedAsset.specification.polygonCount == 0 ? 'Play the asset to get the
                                        count' : selectedAsset.specification.polygonCount }}
                                    </sh-text>
                                </div>
                            </sh-grid>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="assetBackground {{theme_color}}">
                <br>
                <sh-grid>
                    <div class="rename-asset-div" columns="8" col-m="12" col-s="12">
                        <div class="assetInfo assetInfo-margin">
                            <div class="details rename-asset-margin">
                                <sh-text class="font-orrange font-super-header display-contents"
                                    *ngIf="!renameEnable">
                                    {{asset.name}}</sh-text>

                                <!-- <div *ngIf="showEdit && renameEnable"> -->
                                <div *ngIf="modifyToken && renameEnable">
                                    <sh-input-text label='Asset Name' [value]="editedAssetName"
                                        (value-changed)="editedAssetName= $event.target.value !== ''? $event.target.value : editedAssetName"
                                        id="renameAsset"
                                        [error]="assetNameError || assetNameExists || !assetNameValidFlg"
                                        maxlength="60"></sh-input-text>
                                    <sh-icon class="display-inline-box" button color="secondary" icon="success"
                                        id="success" (click)="renameAsset()"></sh-icon>
                                    <sh-icon class="display-inline-box" button icon="error" id="cancel"
                                        (click)="renameEnable = false;assetNameError = false; assetNameExists = false">
                                    </sh-icon>
                                    <sh-tooltip *ngIf="assetNameError" label="Please enter the Asset Name"
                                        target="renameAsset" placement="bottom-left" variation="short"></sh-tooltip>
                                    <sh-tooltip *ngIf="assetNameExists"
                                        label="The entered Asset Name (case insensitive) exists. Please enter a different Asset Name"
                                        target="renameAsset" placement="bottom-left" variation="short"></sh-tooltip>
                                    <sh-tooltip *ngIf="!assetNameValidFlg" title="Rules for asset name:"
                                        label="Cannot start/end with '-' and '_'. Any other special characters are not allowed."
                                        target="renameAsset" placement="bottom-left">
                                    </sh-tooltip>
                                </div>

                                <sh-icon id="editAssetBtn" button icon="edit"
                                    *ngIf="modifyToken===true && !renameEnable" class="display-inline-box position-relative rename-asset-btn"
                                    (click)="editedAssetName = asset.name;renameEnable = true;"></sh-icon>

                                <sh-user-identifier (click)="navigateToProfile()"
                                    name={{asset.attributes.primaryContact.name}} *ngIf="!renameEnable"
                                    [image]="'url(' + (assetProfileImageURL) + ')'">
                                </sh-user-identifier>
                            </div>
                            <div class="asset-rating">
                                <app-rating [rating]="asset.avgRating" [aseetId]="asset._id"></app-rating>
                            </div>
                            <div class="details product-status">
                                <svg height="16" width="16" *ngIf="asset.attributes.productStatus === 0">
                                    <circle cx="10" cy="10" r="6" fill="#efdd59" />
                                </svg>
                                <svg height="16" width="16" *ngIf="asset.attributes.productStatus === 1">
                                    <circle cx="10" cy="10" r="6" fill="#57EE1E" />
                                </svg>
                                <span>
                                    <sh-text class="product-status-text">
                                        {{asset.attributes.productStatus | productStatus}}
                                    </sh-text>
                                </span>
                            </div>
                            <!-- <div class="details">
                                <sh-icon id="editAssetStatusBtn" button icon="edit" style="font-size: 1.5em;"
                                    onclick="document.getElementById('changeProductStatusModal').setAttribute('visible','true')"
                                    (click)="prodStatus=asset.attributes.productStatus"
                                    [disabled]="!checkModifyPermissions()"></sh-icon>
                            </div> -->

                            <div class="details">
                                <sh-dropdown *ngIf="versionList && versionList.length > 0 && !renameEnable"
                                    id="dropdown_version" label='Version' [value]=selectedVersion class="display-inline-box version-dropdown">
                                    <sh-menu-item *ngFor="let v of versionList;let i = index" id="h{{i}}"
                                        label="{{v.version}}{{v.deleted ? ' - deleted' : ''}}"
                                        (click)="selectedVersion = v.version; changeVersion(v.version)"
                                        [disabled]="v.deleted">
                                    </sh-menu-item>
                                </sh-dropdown>
                            </div>
                            <div class="details asset-info-margin">
                                <div class="assetInfo">
                                    <sh-icon class="favorite-icon" color="secondary" icon="favorite"></sh-icon>
                                    <sh-text class="font-body-1 no-of-ratings">
                                        {{httpService.assetDetails?.noOfRatings}}
                                    </sh-text>
                                </div>
                            </div>
                            <div class="details asset-info-margin">
                                <sh-text class="font-title-1 creation-date-text">
                                    Published {{asset.attributes.creationDate | dateToInterval}}
                                </sh-text>
                            </div>
                            <div class="details cursor-pointer subscribe-div" (click)="inform(asset)"
                                id="divSubscribe">
                                <svg *ngIf="!asset.inform" class="heart" viewBox="0 0 32 29.6">
                                    <path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                                                c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z" />
                                </svg>
                                <svg *ngIf="asset.inform" class="heart-selected" viewBox="0 0 32 29.6">
                                    <path d="M23.6,0c-3.4,0-6.3,2.7-7.6,5.6C14.7,2.7,11.8,0,8.4,0C3.8,0,0,3.8,0,8.4c0,9.4,9.5,11.9,16,21.2
                                                c6.1-9.3,16-12.1,16-21.2C32,3.8,28.2,0,23.6,0z" />
                                </svg>
                            </div>
                            <div class="details cursor-pointer keep-me-informed" (click)="inform(asset)">
                                <sh-text class="font-header-1">Keep me informed</sh-text>
                            </div>
                            <div class="details provider-app">
                                <sh-text class="font-title-1 provider-app-text">
                                    Provided by {{asset.applicationId | appName : applications}}
                                </sh-text>
                            </div>
                        </div>
                    </div>
                    <div columns="4" col-m="12" col-s="12" class="details download-asset-div">
                        <ng-container *ngIf="downloadToken === true">
                            <sh-button class="download-asset-btn" shape="pill-m" label='Download'
                                (click)="checkUserDownloadPermission()" id="btndownload"></sh-button>
                        </ng-container>

                        <sh-button class="download-asset-btn" color="secondary"
                            *ngIf="modifyToken === true" shape="pill-s" label='Modify' id="modifyAsset"
                            onclick="document.getElementById('my-modal').setAttribute('visible', 'true')"
                            (click)="modifyAsset();prodStatus = asset.attributes.productStatus"></sh-button>

                        <sh-button class="download-asset-btn" color="secondary"
                            *ngIf="deleteToken === true" shape="pill-s" id="deleteAsset" label='Delete'
                            (click)="deleteConfirmationPopUp()">
                        </sh-button>
                    </div>
                </sh-grid>
            </div>
            <div class="description-section">
                <sh-grid>
                    <div columns="7" col-m="12" col-s="12">
                        <div class="details description-div">
                            <sh-text class="font-title-1 display-contents" *ngIf="asset.description">
                                Description</sh-text>

                            <div *ngIf="modifyToken && editDescriptionEnable">
                                <sh-input-text textarea label='Description' [value]="editedDescription" maxlength="200"
                                    (value-changed)="editedDescription= $event.target.value !== ''? $event.target.value : editedDescription"
                                    id="renameAsset"></sh-input-text>
                                <sh-icon class="display-inline-box" button color="secondary" icon="success"
                                    id="success" (click)="editDescription()"></sh-icon>
                                <sh-icon class="display-inline-box" button icon="error" id="cancel"
                                    (click)="editDescriptionEnable = false; editedDescription = asset.description">
                                </sh-icon>
                            </div>

                            <sh-icon id="editDescBtn" button icon="edit"
                                *ngIf="modifyToken===true && !editDescriptionEnable" class="display-inline-box position-relative edit-desc-btn"
                                (click)="editedDescription = asset.description; editDescriptionEnable = true;">
                            </sh-icon>

                            <div>
                                <sh-text class="font-body-1 desc-text">
                                    {{asset.description}}</sh-text>
                            </div>
                        </div>
                    </div>
                    <div columns="5" col-m="12" col-s="12">
                    </div>
                    <div columns="7" col-m="12" col-s="12">
                        <sh-tabs>
                            <sh-tab-item label="Last Visited" [active]="assetSuggestion === 1" (click)="remix=false">
                            </sh-tab-item>
                            <sh-tab-item label="Recommended" disabled></sh-tab-item>
                            <sh-tab-item label="Latest" disabled></sh-tab-item>
                            <sh-tab-item label="Remix" (click)="getRemix()" [active]="assetSuggestion === 2">
                            </sh-tab-item>

                            <sh-tab-item label="Remixes" (click)="getRemixes()" [active]="assetSuggestion === 3">
                            </sh-tab-item>

                        </sh-tabs>
                        <div *ngIf="assetSuggestion === 1">
                            <app-last-visited [assets]="userService.loggendInUser.assetsRecentlyViewed">
                            </app-last-visited>
                        </div>

                        <ng-container *ngIf="remix && 'assetSuggestion === 2'">
                            <div class="cursor-pointer remix-asset" columns="3" col-m="6" col-s="12">
                                <app-asset-card [asset]="assetRemixed"></app-asset-card>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="remixes && 'assetSuggestion === 3'">
                            <sh-grid *ngIf="remixedFromAssetList.length > 0">
                                <ng-container *ngFor="let assetRemix of remixedFromAssetList">
                                    <div class="remixed-from-asset" columns="3" col-m="6" col-s="12">
                                        <app-asset-card [asset]="assetRemix"></app-asset-card>
                                    </div>
                                </ng-container>
                            </sh-grid>
                            <sh-button shape="pill-m" *ngIf="isShowMoreVisible" color="secondary" label='Show More'
                                id="btnShowMore"
                                (click)="showMoreRemixes()"></sh-button>
                        </ng-container>
                    </div>
                    <div columns="5" col-m="12" col-s="12" *ngIf="asset?.comments">
                        <sh-grid>
                            <div columns="12">
                                <app-comments [asset]="asset" [selectedVersion]="selectedVersion">Loading...
                                </app-comments>
                            </div>
                        </sh-grid>
                    </div>
                </sh-grid>
            </div>
        </div>
    </div>

</sh-page>
<sh-drawer position="left" label="Library Browser" id="drawer-left">
    <app-library-browser [assetLibrary]="library" class="outline-none" (selectedAsset)="selectAsset($event)"
        (folderSelected)="folderselected($event)" #libBrowser [isPersonalBrowser]="false"
        (assetCardId)="fetchCardDetails($event)" (assetRelativePath)="assetRelativePathRecive($event)"
        (parameterUrl)="parameterUrl($event)">
    </app-library-browser>
</sh-drawer>

<!-- Modals -->
<div *ngIf="asset">
    <sh-modal id="my-modal" label="Modify" *ngIf="updateText === 'Modify'" (modal-closed)="cancelEdit()">
        <div *ngIf="edit">

            <sh-input-text label='Primary Contact Name' name="pcName" ngDefaultControl
                [value]="asset.attributes.primaryContact.name"
                (value-changed)="asset.attributes.primaryContact.name=$event.target.value"
                [formControl]="primaryContactNameControl" [error]="primaryContactNameControl.invalid" id="pcName">
            </sh-input-text>
            <sh-tooltip *ngIf="primaryContactNameControl.invalid" label="Please enter the Primary Contact Name"
                target="pcName" placement="bottom-right" variation="short"></sh-tooltip>

            <br>

            <sh-input-text label='Primary Contact Email Address' name="pcEmail" ngDefaultControl
                [value]="asset.attributes.primaryContact.emailId"
                (value-changed)="asset.attributes.primaryContact.emailId=$event.target.value"
                [formControl]="primaryContactEmailControl" [error]="primaryContactEmailControl.invalid" id="pcEmail">
            </sh-input-text>
            <sh-tooltip *ngIf="primaryContactEmailControl.hasError('required')"
                label="Please enter the Primary Contact Email Id" target="pcEmail" placement="bottom-right"
                variation="short"></sh-tooltip>
            <sh-tooltip
                *ngIf="primaryContactEmailControl.hasError('pattern') || primaryContactEmailControl.hasError('email')"
                label="Please enter a valid Primary Contact Email Id" target="pcEmail" placement="bottom-right"
                variation="short"></sh-tooltip>

            <br>
            <br>

            <div class="outline-0">
                <sh-radio-group>
                    <p class="outline-0">Product Status</p>
                    <sh-radio-button label="Not Commercially Ready" id="productstatus1"
                        [active]="asset.attributes.productStatus == 0"
                        [ngStyle]="{'pointer-events': checkModifyPermissions() ? 'auto' : 'none'}"
                        [disabled]="!checkModifyPermissions()" (click)="asset.attributes.productStatus = 0">
                    </sh-radio-button>
                    <sh-radio-button label="Commercially Ready" [active]="asset.attributes.productStatus == 1"
                        (click)="asset.attributes.productStatus = 1"
                        [ngStyle]="{'pointer-events': checkModifyPermissions() ? 'auto' : 'none'}"
                        [disabled]="!checkModifyPermissions()">
                    </sh-radio-button>
                </sh-radio-group>
            </div>

            <br>
            <br>

            <div class="outline-0">
                <sh-radio-group>
                    <p class="outline-0">Accessibility</p>
                    <sh-radio-button label="Private" id="accessibility1" [active]="asset.attributes.visibility == 0"
                        [ngStyle]="{'pointer-events': checkModifyPermissionsForUploaders() ? 'auto' : 'none'}"
                        [disabled]="!checkModifyPermissionsForUploaders()" (click)="asset.attributes.visibility = 0">
                    </sh-radio-button>
                    <sh-radio-button label="Public" [active]="asset.attributes.visibility == 1"
                        [ngStyle]="{'pointer-events': checkModifyPermissionsForUploaders() ? 'auto' : 'none'}"
                        [disabled]="!checkModifyPermissionsForUploaders()" (click)="asset.attributes.visibility = 1">
                    </sh-radio-button>
                  <sh-radio-button label="Restricted" [active]="asset.attributes.visibility == 2"
                        [ngStyle]="{'pointer-events': checkModifyPermissionsForUploaders() ? 'auto' : 'none'}"
                        [disabled]="!checkModifyPermissionsForUploaders()" (click)="asset.attributes.visibility = 2">
                    </sh-radio-button>
                </sh-radio-group>
            </div>

            <div class="outline-0">

                <p class="outline-0">Specifications</p>
                <div class="assetDetailsGrid">
                    <sh-checkbox label='Rigged' id="cbspecificationrigged" [active]="assetFileSpecifaction.rigged"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'rigged')"></sh-checkbox>
                    <sh-tooltip
                        label="Rigged: In its simplest form, 3D rigging is the process of creating a skeleton for a 3D model so it can move. Most commonly, characters are rigged before they are animated because if a character model doesn't have a rig, they can't be deformed and moved around"
                        target="cbspecificationrigged" placement="bottom-right" variation="short"></sh-tooltip>
                    <sh-checkbox label='Animation' id="cbspecificationanimation"
                        [active]="assetFileSpecifaction.animation"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'animation')"></sh-checkbox>
                    <sh-tooltip
                        label="Animation: Animating objects that appear in a three-dimensional space. They can be rotated and moved like real objects. 3D animation is at the heart of games and virtual reality, but it may also be used in presentation graphics to add flair to the visuals."
                        target="cbspecificationanimation" placement="bottom-right" variation="short"></sh-tooltip>
                    <sh-checkbox disabled label='Movement Logic' [active]="assetFileSpecifaction.movementLogic"
                        id="cbspecificationmovement"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'movementLogic')"></sh-checkbox>

                    <sh-checkbox disabled label='User Interaction' [active]="assetFileSpecifaction.userInteraction"
                        id="cbspecificationuserInteraction"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'userInteraction')"></sh-checkbox>
                    <sh-checkbox disabled label='Update Via Git'
                        [active]="assetFileSpecifaction.automaticallyUpdateViaGit" id="cbspecificationupdatedviagit"
                        (click)="changeCheckBoxValue(assetFileSpecifaction,'automaticallyUpdateViaGit')"></sh-checkbox>
                </div>

                <br>
            </div>

            <div class="outline-0">
                <p class="outline-0">Provider Application</p>
                <sh-dropdown label="Application" mandatory>
                    <sh-menu-item *ngFor="let app of applications;let i = index;" label="{{app.name}}" [active]="app._id == asset.applicationId" (click)="updateApplicationId(app)"></sh-menu-item>
                </sh-dropdown>
            </div>

        </div>
        <div *ngIf="!edit" class="outline-0 modify">
            <div id="div_editAssetInfo">
                <sh-icon slot="functions" button icon="edit"
                    id="search_editAssetInfo" (click)="edit = true">
                </sh-icon><br>
                <sh-text
                    class="cursor-pointer font-body-1 edit-asset-info-text" (click)="edit = true">Edit asset related
                    info</sh-text>

            </div>
            <div id="div_AddNewVersion">
                <sh-icon class="add-new-version-icon" slot="functions" *ngIf="versionList && versionList.length > 0" button icon="plus"
                    id="search_AddNewVersion" (click)="newVersion()">
                </sh-icon><br>
                <sh-text class="cursor-pointer font-body-1 add-new-version" (click)="newVersion()">New version</sh-text>

            </div>
            <div id="div_AddNewExtension">
                <sh-icon class="add-new-extension-icon" slot="functions" button icon="copy-reference-new" (click)="newExtension()"
                    id="search_AddNewExtension"></sh-icon><br>
                <sh-text class="cursor-pointer font-body-1 add-new-extension" (click)="newExtension()">Add new extension</sh-text>
            </div>
            <div id="div_UpdateAssetFile">
                <sh-icon class="update-asset-icon" slot="functions" *ngIf="versionList && versionList.length > 0" button icon="export"
                    (click)="updateAssetFile()" id="search_UpdateAssetFile"></sh-icon><br>
                <sh-text class="cursor-pointer font-body-1 update-asset" (click)="updateAssetFile()">Update Asset
                    File</sh-text>

            </div>
        </div>

        <!-- <sh-button slot='footer' color='secondary' label='Cancel' id="bcancel"></sh-button>
              <sh-button slot='footer' label='Upload' id="bupload"></sh-button> -->
        <!-- <div>
              <sh-card label='3D Files'>
                  <h1>Hi</h1>
              </sh-card>
          </div> -->
        <!-- <sh-text p>Are you sure you want to delete this file?</sh-text> -->
        <!-- any component can close the modal by removing the 'visible' attribute -->
        <sh-button color='tertiary' slot='footer' label='Cancel'
            onclick="document.getElementById('my-modal').removeAttribute('visible')" id="updateAssetInfoBtnCancel"
            (click)="cancelEdit()"></sh-button>
        <sh-button color='secondary' slot='footer' id="updateAssetInfoBtn" *ngIf="edit" label='Update'
            (click)="updateAsset()"></sh-button>
    </sh-modal>
</div>

<div>
    <div id="overlay" *ngIf="loader">
        <div class="loader">
            <sh-spinner label="Loading"></sh-spinner>
        </div>
    </div>
    <div #rendererContainer></div>
</div>

<sh-modal id="delete-confirmation" type='alert' label='Delete Asset' modal-height='184px' modal-width='450px'>
    <sh-text p>Are you sure you want to delete the asset?</sh-text>
    <sh-button color='tertiary' slot='footer' label='Delete' (click)="deleteAsset()" id="deleteEntireAsset"></sh-button>
    <sh-button color='tertiary' slot='footer' label='Delete version' shape="pill-m" (click)="deleteAssetVersion()"
        *ngIf="validVersions > 1" id="deleteAssetVersion"></sh-button>
    <sh-button color='tertiary' slot='footer' label='Cancel'
        onclick="document.getElementById('delete-confirmation').removeAttribute('visible')" id="cancelDelete">
    </sh-button>
</sh-modal>

<sh-notifications class="notification-tab">
    <sh-notification-item type="confirmation" label="Success" id="success" [visible]="showSuccess">
        {{showSuccessMessage}}
    </sh-notification-item>
    <sh-notification-item type="error" label="Error" id="failure" [visible]="showFailure">
        {{showFailureMessage}}
    </sh-notification-item>
</sh-notifications>

<sh-modal id="Download" [label]='downloadAssetLevel' modal-height='550px' modal-width='600px'
    *ngIf="selectedAsset?.specification">

    <sh-tabs>
        <!-- active tab-items have the 'active' property, this property is transferred to clicked tabs -->
        <sh-tab-item id="defaultOpen" class="active-item-tab tablinks" label="Asset"
            (click)="openTab(this,'assetInfoId',0)" active></sh-tab-item>
        <sh-tab-item id="fileTab" class="active-item-tab tablinks" label="Files"
            (click)="openTab(this,'filesInfoId',1)"></sh-tab-item>
    </sh-tabs>

    <sh-grid id="assetInfoId" class="tabcontent">
        <ng-container *ngIf="downloadStarted === true">
            <div columns="12">
                <sh-progress class="download-progress" info='Preparing to download files...' [value]='downloadValue'>
                </sh-progress>
            </div>
        </ng-container>
        <div columns="3">
            <sh-checkbox label='3D-Model' class="pointer-events-none" id="cb3DFile"
                [active]="selectedAsset.specification.fileType === '3D'"></sh-checkbox>

        </div>
        <div columns="9">
            <sh-grid>
                <div *ngIf="experiencedMode" columns="4">
                    <sh-text class="font-body-2">Quality</sh-text>
                    <sh-radio-group [value]=selectedAsset.specification.fileQuality
                        (value-changed)="selectedAsset.specification.fileQuality=$event.target.value">

                        <sh-radio-button id="rbFileHigh" label="High"
                            [active]="selectedAsset.specification.fileQuality === 0"
                            (click)="selectAssetOnFileQuality(0, selectedAsset.specification.textureQuality)"
                            [disabled]="quality.indexOf(0) < 0"></sh-radio-button>
                        <sh-radio-button id="rbFileMedium" label="Medium"
                            [active]="selectedAsset.specification.fileQuality === 1"
                            (click)="selectAssetOnFileQuality(1, selectedAsset.specification.textureQuality)"
                            [disabled]="quality.indexOf(1) < 0"></sh-radio-button>
                        <sh-radio-button id="rbFileLow" label="Low"
                            [active]="selectedAsset.specification.fileQuality === 2"
                            (click)="selectAssetOnFileQuality(2, selectedAsset.specification.textureQuality)"
                            [disabled]="quality.indexOf(2) < 0"></sh-radio-button>
                    </sh-radio-group>
                </div>
                <div *ngIf="experiencedMode" columns="4">
                    <sh-text class="font-body-2">File Format</sh-text>
                    <sh-radio-group>
                        <sh-radio-button id="rbFileFormat" *ngFor="let f of formats" [label]="getLabel(f)"
                            [active]="selectedAsset.specification.fileFormat === f"
                            (click)="selectedAsset.specification.fileFormat = f; qualityForSelectedFormat(f)">
                        </sh-radio-button>

                    </sh-radio-group>
                </div>
            </sh-grid>
        </div>
        <div columns="3">
            <sh-checkbox label='Texture' class="pointer-events-none" active id="cbTexture"></sh-checkbox>
        </div>
        <div columns="9">
            <sh-grid>
                <div *ngIf="experiencedMode" columns="4">
                    <sh-text class="font-body-2">Quality</sh-text>
                    <sh-radio-group>

                        <sh-radio-button id="rbTextureHigh" label="High"
                            [active]="selectedAsset.specification.textureQuality=== 0"
                            (click)="selectAssetOnTextureQuality(selectedAsset.specification.fileQuality,0)"
                            [disabled]="textureQuality.indexOf(0) < 0"></sh-radio-button>
                        <sh-radio-button id="rbTextureMedium" label="Medium"
                            [active]="selectedAsset.specification.textureQuality === 1"
                            (click)="selectAssetOnTextureQuality(selectedAsset.specification.fileQuality,1)"
                            [disabled]="textureQuality.indexOf(1) < 0"></sh-radio-button>
                        <sh-radio-button id="rbTextureLow" label="Low"
                            [active]="selectedAsset.specification.textureQuality === 2"
                            (click)="selectAssetOnTextureQuality(selectedAsset.specification.fileQuality,2)"
                            [disabled]="textureQuality.indexOf(2) < 0"></sh-radio-button>
                    </sh-radio-group>
                </div>
            </sh-grid>
        </div>

        <div columns="2" class="container">

            <sh-checkbox *ngIf="selectedAsset.specification.rigged || experiencedMode" id="cbRigged" label='Rigged'
                [active]="selectedAsset.specification.rigged && !selectAsset.deleted" class="pointer-events-none">
            </sh-checkbox>

        </div>
        <div columns="10">
            <sh-grid>
                <div columns="4">
                    <sh-checkbox id="cbAnimation" *ngIf="selectedAsset.specification.animation || experiencedMode"
                        label='Animation' [active]="selectedAsset.specification.animation && !selectAsset.deleted"
                        class="pointer-events-none">
                    </sh-checkbox>

                </div>
            </sh-grid>
        </div>
        <div columns="2">
            <sh-checkbox label='Moment Logic' disabled
                *ngIf="selectedAsset.specification.movementLogic||experiencedMode" id="cbMovement"
                [active]="selectedAsset.specification.movementLogic && !selectAsset.deleted"
                class="pointer-events-none"></sh-checkbox>
        </div>
        <div columns="10">
            <sh-checkbox disabled label='User Interaction'
                *ngIf="selectedAsset.specification.userInteraction||experiencedMode" id="cbUserInteraction"
                [active]="selectedAsset.specification.userInteraction && !selectAsset.deleted"
                class="pointer-events-none"></sh-checkbox>
        </div>

        <div columns="4">
            <sh-checkbox disabled label='Automaticaly update via GIT' class="pointer-events-none"
                *ngIf="selectedAsset.specification.automaticallyUpdateViaGit||experiencedMode" id="cbUpdatedViaGit"
                [active]="selectedAsset.specification.automaticallyUpdateViaGit && !selectAsset.deleted"></sh-checkbox>
        </div>
    </sh-grid>

     <sh-grid id="filesInfoId" class="tabcontent">
        <div columns="9" *ngIf="isConsentFormDownloadPermission">
            <sh-grid>
                <div columns="4">
                    <sh-checkbox class="pointer-events-all pointer-events-cursor" label="Consent Form" *ngIf="experiencedMode"
                        (click)="isConsentFormSelected = !isConsentFormSelected" id="consentFormDownload">
                    </sh-checkbox>
                </div>
            </sh-grid>
        </div>
    </sh-grid>

    <sh-button id="downloadAssetId" slot='footer' label='Download' shape="pill-m" [disabled]="downloadStarted"
        (click)=" enableDownloadButtonForAsset === true ? download() : downloadFiles()">
    </sh-button>
</sh-modal>
